<template>
  <div class="info section">
    <h2>{{ $t('information.informacion') }}</h2>
    <div class="separator" />
    <b-row class="no-gutters">
      <b-col v-if="description"
             :sm="textSize.sm"
             :lg="textSize.lg"
             cols="12"
             class="pR10 tAl">
        <text-truncate>
          <p>{{ description }}</p>
        </text-truncate>
        <p v-if="tags.length > 0"
           class="may-also-like">
          <span>{{ $t('information.tambienTePuedeInteresar') }}</span>
          <br>
          <strong>
            <a v-for="(tag, index) in tags"
               :key="index"
               :to="tag.url"
               :title="tag.label">
              {{ tag.label }}<span v-if="index !== tags.length - 1">,</span>
            </a>
          </strong>
        </p>
        <ul v-if="links"
            class="social-links-list">
          <li v-for="link in links"
              :key="link.id">
            <a :href="link.url"
               :title="link.url"
               target="_blank"
               rel="noopener nofollow">
              <i :class="`icon-social icon-${link.type}`" />
            </a>
          </li>
        </ul>
        <div class="general-data">
          <p v-if="startDate"
             class="general-data-date">{{ startDate | moment("utc", "D MMM YYYY") }} <span v-if="itemType === 'event' && type === 1 && endDate"
                  class="general-data-date">- {{ endDate | moment("utc", "D MMM YYYY") }}</span></p>
          <div v-if="companies.length > 0">
            <p class="general-data-more">
              {{ $t('information.verMasConciertosDe') }}
              <span v-for="(company, index) in companies"
                    :key="company.id">
                <a :href="company.permalink"
                   :title="company.name"
                   class="underline-white-topaz">{{ company.name }}</a>
                <span v-if="index !== companies.length -1">,</span>
              </span>
            </p>
          </div>
        </div>
      </b-col>
      <b-col v-if="spotify"
             sm="4"
             lg="6"
             cols="12">
        <b-embed :src="`https://embed.spotify.com/?uri=spotify:artist:${spotify}`"
                 title="Spotify"
                 type="iframe"
                 aspect="16by9" />
      </b-col>
      <localization v-if="venue"
                    id="localization"
                    class="localization-venue"
                    :venue="venue"
                    :title="false" />
      <b-col v-if="program && program.media && program.media.length > 0"
             sm="3"
             lg="5"
             cols="12"
             class="container-program">
        <b-img :src="programImgSelected.thumbnails ? programImgSelected.thumbnails.s_dt : require('@/assets/images/placeholder-event.svg')"
               :alt="programImgSelected.description"
               fluid
               class="program-image"
               @click="openFullScreen"
               @error.native="$event.target.src = require('@/assets/images/placeholder-event.svg')" />
        <div class="container-arrows">
          <span v-if="program.media.length > 1"
                class="arrow left"
                @click="prev()"></span>
          <span>{{ programSelected }}</span>
          <span>de</span>
          <span>{{ program.media.length }}</span>
          <span v-if="program.media.length > 1"
                class="arrow right"
                @click="next()"></span>
        </div>
      </b-col>
    </b-row>
    <full-screen v-if="openedFullScreen"
                 class="full-screen-info">
      <slider :type="'full-screen-slider'"
              :elements="program.media"
              :element-init-id="programSelected"
              class="full-screen-slider" />
    </full-screen>
  </div>
</template>

<script>
import Slider from '@/components/slider/Slider.vue'
import TextTruncate from '@/components/text-truncate/TextTruncate.vue'
import Localization from '@/components/localization/Localization.vue'
import FullScreen from '@/components/full-screen/FullScreen.vue'
import SignupPurchase from '@/components/signup-purchase/SignupPurchase.vue'

export default {
  components: {
    Slider,
    TextTruncate,
    Localization,
    FullScreen,
    SignupPurchase
  },
  props: {
    itemType: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 2
    },
    description: {
      type: String,
      default: ''
    },
    links: {
      type: Array,
      default: () => []
    },
    spotify: {
      type: String,
      default: ''
    },
    startDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    },
    companies: {
      type: Array,
      default: () => []
    },
    tags: {
      type: Array,
      default: () => []
    },
    venue: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      openedFullScreen: false,
      programSelected: 1,
      programImgSelected:
        this.$store.state.gallery.program &&
        this.$store.state.gallery.program.media &&
        this.$store.state.gallery.program.media.length > 0
          ? this.$store.state.gallery.program.media[0]
          : { thumbnails: {} }
    }
  },
  computed: {
    textSize() {
      if (this.spotify) {
        return {
          sm: 8,
          lg: 6
        }
      } else if (
        this.$store.state.gallery.program &&
        this.$store.state.gallery.program.media &&
        this.$store.state.gallery.program.media.length > 0
      ) {
        return {
          sm: 9,
          lg: 7
        }
      }
      return {
        sm: 12,
        lg: 12
      }
    },
    program() {
      return this.$store.state.gallery.program
    }
  },
  created() {
    this.$root.$on('closeFullScreen', () => {
      this.openedFullScreen = false
    })
  },
  methods: {
    prev() {
      if (this.programSelected - 1 > 1) {
        this.programSelected--
        this.programImgSelected = this.$store.state.gallery.program.media[
          this.programSelected - 1
        ]
      }
    },
    next() {
      if (
        this.programSelected + 1 <=
        this.$store.state.gallery.program.media.length
      ) {
        this.programSelected++
        this.programImgSelected = this.$store.state.gallery.program.media[
          this.programSelected - 1
        ]
      }
    },
    openFullScreen() {
      this.openedFullScreen = true
    }
  }
}
</script>

<style lang="scss">
@import './information.sass';
.full-screen-slider {
  width: 80%;
  margin: auto;
  top: 10%;
  height: 80%;
  .localization-venue {
    margin-top: 25px;
  }
}
</style>
